import React, { useEffect, useState } from 'react';
import { useSaveStatementIqSettings, useStatementIqSettings } from '../../../services/statementIqSettings';

export default function StatementIqSettingsPanel() {
  const settings = useStatementIqSettings();
  const save = useSaveStatementIqSettings();
  const [enabled, setEnabled] = useState(false);
  const [error, setError] = useState('');
  const [saved, setSaved] = useState(false);
  useEffect(() => { if (settings.data) setEnabled(settings.data.enabled); }, [settings.data]);

  if (settings.isPending) return <p role="status">Loading StatementIQ settings…</p>;
  if (settings.isError) return <div role="alert">
    <p>StatementIQ settings could not be loaded.</p>
    <button type="button" className="btn btn-outline-primary" onClick={() => settings.refetch()}>Retry</button>
  </div>;

  return <form onSubmit={async event => {
    event.preventDefault(); setError(''); setSaved(false);
    try { await save.mutateAsync({ enabled }); setSaved(true); }
    catch (failure: any) { setError(failure?.response?.data?.message || 'StatementIQ settings could not be saved.'); }
  }}>
    <h5 className="mb-3">StatementIQ</h5>
    <div className="form-check form-switch mb-3">
      <input id="statementiq-enabled" type="checkbox" className="form-check-input" checked={enabled}
        disabled={save.isPending} onChange={event => { setEnabled(event.target.checked); setSaved(false); }} />
      <label className="form-check-label" htmlFor="statementiq-enabled">Enable StatementIQ</label>
    </div>
    <p className="text-muted">Analyse bank statements during individual applications. When disabled, use the normal document uploads. Saved statements and results remain available.</p>
    {error && <p role="alert" className="text-danger">{error}</p>}
    {saved && <p role="status" className="text-success">StatementIQ settings saved.</p>}
    <button type="submit" className="btn btn-primary" disabled={save.isPending || !settings.data || enabled === settings.data.enabled}>
      {save.isPending ? 'Saving…' : 'Save Changes'}
    </button>
  </form>;
}
